import { api } from '@/services/api/AxiosBaseService'
import { createCrudService } from '@/services/api/createCrudService'
import type { ModalityDegreeRelationship } from './ModalitiesService'
import type { SingleResponse } from '@/types/api'

export interface Plan {
  id: string
  productId: string | null
  planTypeRelationshipId: string
  name: string
  planType: 'PESSOA FÍSICA' | 'PESSOA JURÍDICA'
  price: number
  priceInCents: number
  status: 'ATIVO' | 'INATIVO'
  /** Total de titulares (assinantes) vinculados — vem na listagem. */
  subscribersCount?: number | null
  /** Titulares ativos + dependentes ativos deles. */
  livesCount?: number | null

  displayWebsite: boolean

  // Página de vendas (preenchidos quando displayWebsite=true)
  lpOrder:        number | null
  lpName:         string | null
  lpImagePath:    string | null
  lpImageUrl:     string | null
  lpContractPath: string | null
  lpContractUrl:  string | null
  lpCoverage:     string | null
  lpHolder:       string | null
  lpBenefits:     string[] | null
  lpNotes:        string | null

  planTypeRelationship?: {
    id: string
    name: string
    minAge: number | null
    status?: string
    degreeRelationships?: ModalityDegreeRelationship[]
  }
  formatted?: { price?: string; createdAt?: string }
}

const base = createCrudService<Plan>('/commercial/plans')

export const PlansService = {
  ...base,
  async uploadLpImage(planId: string, file: File): Promise<Plan> {
    const fd = new FormData()
    fd.append('image', file)
    const r = await api.post<SingleResponse<Plan>>(`/commercial/plans/${planId}/lp-image`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return r.data.data
  },
  async removeLpImage(planId: string): Promise<Plan> {
    const r = await api.delete<SingleResponse<Plan>>(`/commercial/plans/${planId}/lp-image`)
    return r.data.data
  },
  async uploadLpContract(planId: string, file: File): Promise<Plan> {
    const fd = new FormData()
    fd.append('contract', file)
    const r = await api.post<SingleResponse<Plan>>(`/commercial/plans/${planId}/lp-contract`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return r.data.data
  },
  async removeLpContract(planId: string): Promise<Plan> {
    const r = await api.delete<SingleResponse<Plan>>(`/commercial/plans/${planId}/lp-contract`)
    return r.data.data
  },

  /** Assinantes (titulares) do plano — para exportação. */
  /** Titulares do plano. `activeOnly`: só quem está no plano hoje (ATIVO). */
  async subscribers(planId: string, activeOnly = false): Promise<PlanSubscriberRow[]> {
    const r = await api.get<{ data: PlanSubscriberRow[] }>(`/commercial/plans/${planId}/subscribers`, {
      params: activeOnly ? { active: 1 } : undefined,
    })
    return r.data.data
  },
}

export interface PlanSubscriberRow {
  name: string
  cpf: string | null
  email: string | null
  mobile: string | null
  company: string | null
  card: string | null
  /** Dependentes ativos do titular. */
  dependents: number
  status: string
}
